import { useEffect, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { useUserRules } from '@/entities/user/access-rule';
import { useIsAuth } from '@/entities/user/session';
import { checkRules } from '@/entities/user/access-rule';
import { routes } from '@/app/config/routes';
import { treeSearch } from '@/shared/lib/utils/tree/tree-search';
import { PROFILE } from '@/shared/config/routes';

export const useRouteAccessGuard = () => {
  const { t } = useTranslation('translation');
  const location = useLocation();
  const navigate = useNavigate();
  const isAuth = useIsAuth();
  const { data: userRules, isLoading: isRulesLoading } = useUserRules();

  const currentRoute = useMemo(
    () => treeSearch(routes, 'children', (r) => r.to === location.pathname),
    [location.pathname],
  );

  const hasAccess = useMemo(() => {
    if (!currentRoute) return true;
    if (currentRoute.public) return true;
    if (!currentRoute.rules) return true;
    return checkRules(currentRoute.rules, userRules || []);
  }, [currentRoute, userRules]);

  useEffect(() => {
    if (!isAuth || isRulesLoading || hasAccess) return;

    navigate(PROFILE, { replace: true });
  }, [isAuth, isRulesLoading, hasAccess, navigate, t]);
};